export const tripStatus = (data) => {
    return {
        type: "TRIP",
        payload: data
    }
}